/**
 * Press page — reveal cards on scroll
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-fabpad-press]');
  if (!root) return;

  var items = root.querySelectorAll('[data-press-reveal]');
  if (!items.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    items.forEach(function (item) {
      item.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    }
  );

  items.forEach(function (item, index) {
    item.style.transitionDelay = Math.min(index * 0.06, 0.3) + 's';
    observer.observe(item);
  });
})();
